import React from 'react';

import { Container } from './styles';

const Spinner: React.FC = () => {
  return <Container />;
};

export default Spinner;
